import { FilterField, useUserOptions } from "~/features/filter";

import { useDealerOptions } from "./model/useDealerOptions";
import { useEmailLogNameOptions } from "./model/useEmailLogNameOptions";

type Translate = (key: string) => string;

/**
 * Поля фильтра журнала рассылки: дилеры и пользователи — мультивыбор
 * (в URL сериализуются через запятую), список логов — одиночный селект,
 * даты создания — диапазон с фиксированной шириной.
 * Имена полей совпадают с параметрами API `LogGetter.getEmailLogs`.
 */
export const emailLogsFilterFields = (t: Translate): FilterField[] => [
  {
    name: "dealerIds",
    type: "select",
    label: t("dealership.dealerships"),
    multiple: true,
    optionsHook: useDealerOptions,
  },
  {
    name: "name",
    type: "select",
    label: t("logs.logsList"),
    optionsHook: useEmailLogNameOptions,
  },
  {
    name: "userIds",
    type: "select",
    label: t("logs.users"),
    multiple: true,
    optionsHook: useUserOptions,
  },
  {
    name: "fromDate",
    nameTo: "toDate",
    type: "dateRange",
    label: t("logs.date"),
    placeholder: t("pkd.data_begin"),
    placeholderTo: t("pkd.data_end"),
    fixedWidth: 360,
    disableFutureDates: true,
  },
];
